import React, { createContext, useState, useContext } from 'react';

// Create the context
const AnimationContext = createContext();

// Create a provider component
export const AnimationProvider = ({ children }) => {
  const [animationDirection, setAnimationDirection] = useState('none'); // 'none', 'to-forgot', 'to-login'
  
  // Function to change animation direction
  const setDirection = (direction) => {
    setAnimationDirection(direction);
  };
  
  return (
    <AnimationContext.Provider value={{ animationDirection, setDirection }}>
      {children}
    </AnimationContext.Provider>
  );
};

// Create a custom hook to use the animation context
export const useAnimation = () => {
  const context = useContext(AnimationContext);
  if (!context) {
    throw new Error('useAnimation must be used within an AnimationProvider');
  }
  return context;
};

export default AnimationContext; 